import { render, staticRenderFns } from "./spaceTree.vue?vue&type=template&id=019a8a66&scoped=true"
import script from "./spaceTree.vue?vue&type=script&lang=js"
export * from "./spaceTree.vue?vue&type=script&lang=js"
import style0 from "./spaceTree.vue?vue&type=style&index=0&id=019a8a66&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019a8a66",
  null
  
)

export default component.exports